/* LINEOUT — motion del tema (v5).
   reveal al scroll · tilt 3D · botones magnéticos · count-up · onda de audio.
   Todo respeta prefers-reduced-motion y puntero fino. */
(function(){
  document.documentElement.classList.add('js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* onda de audio: generar barras */
  var wave = document.getElementById('lo-wave');
  if(wave && !wave.children.length){
    for(var i=0;i<64;i++){ var b=document.createElement('i'); b.style.animationDelay=(i*0.045)+'s'; b.style.height=(20+Math.random()*70)+'%'; wave.appendChild(b); }
  }

  /* reveal on scroll */
  var rvs=document.querySelectorAll('.lo-rv');
  if(reduce || !('IntersectionObserver' in window)){
    rvs.forEach(function(e){e.classList.add('lo-in');});
  } else {
    var io=new IntersectionObserver(function(en){
      en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('lo-in'); io.unobserve(e.target);} });
    },{threshold:.16});
    rvs.forEach(function(e){io.observe(e);});
    var hl=document.querySelector('.lo-hero__hl');
    if(hl){ requestAnimationFrame(function(){ setTimeout(function(){hl.classList.add('lo-drawn');},250); }); }
  }

  /* tilt 3D de la tarjeta hero */
  var tilt=document.getElementById('lo-tilt');
  if(tilt && fine && !reduce){
    var wrap=tilt.parentElement, raf;
    wrap.addEventListener('pointermove',function(e){
      var r=tilt.getBoundingClientRect();
      var px=(e.clientX-r.left)/r.width-.5, py=(e.clientY-r.top)/r.height-.5;
      cancelAnimationFrame(raf);
      raf=requestAnimationFrame(function(){
        tilt.classList.remove('lo-float');
        tilt.style.setProperty('--lo-rx',(px*9).toFixed(2)+'deg');
        tilt.style.setProperty('--lo-ry',(-py*9).toFixed(2)+'deg');
      });
    });
    wrap.addEventListener('pointerleave',function(){
      tilt.style.setProperty('--lo-rx','0deg'); tilt.style.setProperty('--lo-ry','0deg');
      setTimeout(function(){tilt.classList.add('lo-float');},300);
    });
  }

  /* botones magnéticos */
  if(fine && !reduce){
    document.querySelectorAll('[data-lo-magnetic]').forEach(function(btn){
      btn.addEventListener('pointermove',function(e){
        var r=btn.getBoundingClientRect();
        var x=(e.clientX-r.left-r.width/2)*.28, y=(e.clientY-r.top-r.height/2)*.4;
        btn.style.transform='translate('+x.toFixed(1)+'px,'+y.toFixed(1)+'px)';
      });
      btn.addEventListener('pointerleave',function(){ btn.style.transform=''; });
    });
  }

  /* count-up de las métricas (parsea el número desde el texto libre) */
  function runCount(scope){
    scope.querySelectorAll('[data-lo-countup]').forEach(function(el){
      if(el.dataset.loDone) return; el.dataset.loDone='1';
      var m=el.textContent.trim().match(/^([^\d.-]*)([\d]+(?:\.[\d]+)?)(.*)$/);
      if(!m){ return; }
      var pre=m[1], numStr=m[2], suf=m[3];
      var dec=numStr.indexOf('.')>=0 ? numStr.split('.')[1].length : 0;
      var target=parseFloat(numStr);
      if(reduce){ return; }
      var t0=null, dur=1100;
      function step(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/dur,1); var e=1-Math.pow(1-p,3);
        el.textContent=pre+(target*e).toFixed(dec)+suf; if(p<1)requestAnimationFrame(step); }
      requestAnimationFrame(step);
    });
  }
  var proof=document.querySelector('.lo-proof-row');
  if(proof){
    if(reduce || !('IntersectionObserver' in window)){ runCount(proof); }
    else{ var po=new IntersectionObserver(function(en){ if(en[0].isIntersecting){ runCount(proof); po.disconnect(); } },{threshold:.5}); po.observe(proof); }
  }
})();
